import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import CassetteMenu from './CassetteMenu';
import CassetteLogo from './CassetteLogo';
import ThemeToggle from './ThemeToggle';
import HeaderBackButton from './HeaderBackButton';
import { SketchNavBar } from './sketchy';
import { useDesignMode } from '../contexts/DesignContext';
import { classNames } from '../utils/classNames';
import { preserveUtmParams } from '../utils/utm';

interface AppNavBarProps {
  showBackButton?: boolean;
}

const AppNavBar: React.FC<AppNavBarProps> = ({ showBackButton = true }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { isSketchy } = useDesignMode();

  const handleLogout = async () => {
    try {
      await logout();
      navigate(preserveUtmParams('/auth/login'), { replace: true });
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <SketchNavBar>
      <div className="max-w-6xl mx-auto w-full">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center gap-3 min-w-0">
            <button
              onClick={() => navigate('/dashboard')}
              className={classNames(
                'flex items-center gap-2 cursor-pointer transition-colors shrink-0',
                isSketchy ? 'hover:opacity-80' : 'rounded-lg hover:bg-[var(--color-hover)]'
              )}
              aria-label="cassette.diy - Go to Dashboard"
            >
              <div className="flex items-center justify-center" style={{ height: '40px' }}>
                <CassetteLogo className="w-[60px] h-[48px] sm:w-10 sm:h-7" />
              </div>
              <span className="hidden sm:inline text-lg sm:text-xl font-bold text-[var(--color-text)] hover:text-[var(--brand-from)] transition-colors">
                cassette.diy
              </span>
            </button>
            {showBackButton && <HeaderBackButton />}
          </div>
          <div className="flex items-center gap-1 shrink-0">
            <ThemeToggle />
            <CassetteMenu
              user={{
                email: user?.email || '',
                displayName: user?.displayName || undefined,
                photoURL: user?.photoURL || undefined,
              }}
              handleLogout={handleLogout}
            />
          </div>
        </div>
      </div>
    </SketchNavBar>
  );
};

export default AppNavBar;
